var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "clock", staticClass: "clock" }, [
    _c("span", { staticClass: "time" }, [_vm._v(_vm._s(_vm.recordingTime))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }